import moment from 'moment';

export const defaultDateFormat = 'M/DD/YYYY';
export const defaultLongDateFormat = 'dddd, MMMM Do YYYY';
export const defaultTimeFormat = 'h:mm A';
export const defaultDateTimeFormat = 'M/DD/YYYY h:mm A';
export const defaultDateTimeSecondsFormat = 'M/DD/YYYY h:mm:ss A';
export const defaultMonthYearFormat = 'M/YYYY';
const empty = '';

export const formatSize = (amount: number): string => {
  const money = formatPrice(amount);
  return money.substring(0, money.indexOf('.'));
};

export const formatPrice = (amount: number): string =>
  amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

export const formatPriceString = (amount: number): string =>
  `$${formatPrice(amount)}`;

export const formatDate = (date: any): string =>
  getFormattedDate(date, defaultDateFormat);

export const formatLongDate = (date: any): string =>
  getFormattedDate(date, defaultLongDateFormat);

export const formatTime = (date: any): string =>
  getFormattedDate(date, defaultTimeFormat);

export const formatDateTime = (date: any): string =>
  getFormattedDate(date, defaultDateTimeFormat);

export const formatDateTimeWithSeconds = (date: any): string =>
  getFormattedDate(date, defaultDateTimeSecondsFormat);

export const formatMonthYear = (date: any): string =>
  getFormattedDate(date, defaultMonthYearFormat);

const getFormattedDate = (date: any, format: string): string =>
  date && typeof date !== 'undefined' && date !== null
    ? `${moment(date).format(format)}`
    : empty;
